// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Bslx","title":"Info_title__2T3bw","links":"Info_links__1JbCg","link":"Info_link__3h7Um","logo":"Info_logo__6C72R"};